import { Injectable, TemplateRef } from '@angular/core';
import { MatDialog, MatDialogConfig, MatDialogRef, MatDialogClose } from '@angular/material/dialog';
import { ComponentType } from '@angular/cdk/portal';

@Injectable()
export class DialogService {

  constructor(private dialog: MatDialog) {
  }

  open<T, D = any, R = any>(componentOrTemplateRef: ComponentType<T> | TemplateRef<T>, config?: MatDialogConfig<D>): MatDialogRef<T, R> {
    return this.dialog.open(componentOrTemplateRef, this.buildConfig(null, config));
  }

  openSM<T, D = any, R = any>(componentOrTemplateRef: ComponentType<T> | TemplateRef<T>, config?: MatDialogConfig<D>): MatDialogRef<T, R> {
    return this.dialog.open(componentOrTemplateRef, this.buildConfig('sm', config));
  }

  openMD<T, D = any, R = any>(componentOrTemplateRef: ComponentType<T> | TemplateRef<T>, config?: MatDialogConfig<D>): MatDialogRef<T, R> {
    return this.dialog.open(componentOrTemplateRef, this.buildConfig('md', config));
  }

  openLG<T, D = any, R = any>(componentOrTemplateRef: ComponentType<T> | TemplateRef<T>, config?: MatDialogConfig<D>): MatDialogRef<T, R> {
    return this.dialog.open(componentOrTemplateRef, this.buildConfig('lg', config));
  }

  openXL<T, D = any, R = any>(componentOrTemplateRef: ComponentType<T> | TemplateRef<T>, config?: MatDialogConfig<D>): MatDialogRef<T, R> {
    return this.dialog.open(componentOrTemplateRef, this.buildConfig('xl', config));
  }

  openOnRight<T, D = any, R = any>(componentOrTemplateRef: ComponentType<T> | TemplateRef<T>, config?: MatDialogConfig<D>): MatDialogRef<T, R> {
    return this.dialog.open(componentOrTemplateRef, this.buildConfig('right', config));
  }


  private buildConfig = (size = null, config?: MatDialogConfig): MatDialogConfig<any> => {
    const defaults = this.getDefaults(size);
    return { ...defaults, ...config };
  }

  private getDefaults = (size = null): MatDialogConfig<any> => {
    const disableClose = true;
    switch (size) {
      case 'sm':
        return { panelClass: ['lib-modal', 'lib-modal-sm'], disableClose, autoFocus: false };

      case 'md':
        return { panelClass: ['lib-modal', 'lib-modal-md'], disableClose, autoFocus: false };

      case 'lg':
        return { panelClass: ['lib-modal', 'lib-modal-lg'], disableClose, autoFocus: false };

      case 'xl':
        return { panelClass: ['lib-modal', 'lib-modal-xl'], disableClose, autoFocus: false };

      case 'right':
        return {
          panelClass: ['lib-modal'],
          disableClose,
          autoFocus: false,
          position: { right: '0', top: '0' },
          height: '100%',
          width: '420px'
        };

      default:
        return { panelClass: ['lib-modal', 'lib-modal-right'], disableClose, autoFocus: false };
    }
  }

}
